<template>
    <div class="row">
        <div class="col-lg-6 order-2 order-lg-0">
            <b-overlay :show="loading" opacity="0.2">
                <form :name="form.name" :method="form.method" :action="form.action" ref="form" autocomplete="off">
                    <div class="row">
                        <div class="col-6 mb-1">
                            <label class="form-label">İsim</label>
                            <input v-card.holder class="form-control" type="text" v-model="firstName" :name="form.holderFirstName" placeholder="İsim" />
                        </div>
                        <div class="col-6 mb-1">
                            <label class="form-label">Soyisim</label>
                            <input v-card.holder class="form-control" type="text" v-model="lastName" :name="form.holderLastName" placeholder="Soyisim" />
                        </div>
                        <div class="col-12 mb-1">
                            <label class="form-label">Kart Numarası</label>
                            <input v-card.card-number class="form-control" v-mask="'################'" type="text" :name="form.cardNumber" v-model="cardNumber"  placeholder="Kart Numarası"/>
                        </div>
                        <div class="col-6 mb-1">
                            <label class="form-label">Ay</label>
                            <select v-card.expire class="form-control" :name="form.expireMonth" v-model="expireMonth">
                                <option :value="null">Ay</option>
                                <option v-for="m in months" :key="m.value" :value="m.text">{{ m.text }}</option>
                            </select>
                        </div>
                        <div class="col-6 mb-1">
                            <label class="form-label">Yıl</label>
                            <select v-card.expire class="form-control" v-model="expireYear" :name="form.expireYear">
                                <option :value="null">Yıl</option>
                                <option v-for="y in years" :key="y.value" :value="y.value">{{ y.text }}</option>
                            </select>
                            <input :name="form.expiry" type="hidden" id="expDate" :value="expireMonth+''+expireYear"> 
                        </div>
                        <div class="col-12 mb-1">
                            <label class="form-label">CVC</label>
                            <input v-card.cvc class="form-control" type="text" :name="form.cvc" v-model="cvc"  v-mask="'####'" placeholder="CVC"/>
                        </div>
                        <!-- <div class="col-12 mb-1" v-if="canInstallment">
                            <b-form-radio-group v-model="installment" :options="c_installments">
                            </b-form-radio-group>
                        </div> -->
                        <div class="col-12">
                            <div class="bg-light text-right rounded p-1">
                                <div class="d-flex align-items-center mb-1">
                                    <span class="text-muted h4 mb-0 mr-1 text-nowrap">Ödenecek Tutar: </span>
                                    <v-currency-input input-class="text-right currency-font-size" :value="amount" :max="maxAmount" v-on:updateValue="value => $emit('update:amount',value)"></v-currency-input>
                                    <span class="h4 mb-0 ml-1">₺</span>
                                </div>
                                <ul class="list-group mb-1" v-if="canInstallment">
                                    <li v-for="(ins,i) in c_installments" class="list-group-item px-75 py-50" :key="i">
                                        <div class="d-flex align-items-center justify-content-between">
                                            <b-form-radio v-model="installment" :value="ins.value" >{{ ins.text }}&nbsp;<span v-if="ins.com > 1" class="text-muted">({{ ins.com }}%)</span></b-form-radio>
                                            {{ ins.amount }}
                                        </div>
                                    </li>
                                </ul>
                                <button type="button" class="btn btn-success w-100" v-on:click="pay">Öde</button>
                            </div>
                        </div>
                    </div>
                    <input type="hidden" :value="c_amount" name="PurchAmount"/>
                    <input type="hidden" :value="orderId" name="OrderId" />
                    <input type="hidden" :value="orderId" name="Rnd" />
                    <input type="hidden" :value="installment" name="InstallmentCount" />
                    <input type="hidden" :value="hash" name="Hash"/>
                    <input type="hidden" :value="code" name="groupcode"/>
                    <input type="hidden" value="4" name="bankvalue"/>
                    
                    <input type="hidden" v-for="param in parameters" :key="param.Id" :value="param.Value" :name="param.Key" />
                </form>
            </b-overlay>
        </div>
        <div class="col-lg-6 order-0 order-lg-2">
            <div class="d-flex justify-content-center h-100 align-items-center p-2">
                <v-credit-card  ref="card"
                                :card-number="cardNumber" 
                                :expire-month="expireMonth" 
                                :expire-year="expireYear" 
                                :cvc="cvc" 
                                :holder="[firstName || null,lastName || null].join(' ')"></v-credit-card>
            </div>
        </div>
    </div>
</template>

<script>
import { BOverlay,BFormRadio,BFormRadioGroup } from 'bootstrap-vue'
import { SystemParameterApi } from '@/api/system-parameter'
import { PaymentApi } from '@/api/payment'
import { SystemDataApi } from '@/api/system-data'
import VCreditCard from '@/components/v-credit-card/VCreditCard.vue'
import randomatic from 'randomatic'
import crypto from 'crypto-js' 
import { cardDirective } from '@/components/v-credit-card/index'
import VCurrencyInput from '@/components/VCurrencyInput.vue'
import moment from 'moment'
import Additional from '@/utilities/additional'

export default {
    components:{
        BOverlay,
        BFormRadio,
        BFormRadioGroup,
        VCreditCard,
        VCurrencyInput
    },
    directives:{
        "card":cardDirective
    },
    props:{
        bankValue:Number,
        code:String,
        amount:Number,
        maxAmount:Number,
        amountStr:String,
        canInstallment:Boolean,
        installments:{
            type:Array,
            default:()=>[]
        }
    },
    data() {
        return {
            loading:false,
            parameters:[],
            firstName:null,
            lastName:null,
            cardNumber:null,
            expireMonth:null,
            expireYear:null,
            hash:null,
            installment:"0",
            cvc:null,
            months:[],
            years:[],
            orderId:randomatic("0",20),
            form:{
                name:'qnb_finansbank_pay_form',
                method:'post',
                action:'https://vpos.qnbfinansbank.com/Gateway/Default.aspx ',
                holderFirstName:'first-name',
                holderLastName:'last-name',
                cardNumber:'Pan',
                expiry:'Expiry',
                expireMonth:'cardexpiredatemonth',
                expireYear:'cardexpiredateyear',
                cvc:'Cvv2'
            },
        }
    },
    mounted(){
        this.getParameters()
        this.months = Array.from({ length: 12 }, (_, i) => i).map(i=>{
            return {
                text: i+1 < 10 ? `0${i+1}` : `${i+1}`,
                value:i+1
            }
        })
        this.years = Array.from({ length: 50 }, (_, i) => i).map(i=>{
            let year = moment().add(i,'years').format('YYYY')
            return {
                text: year,
                value: year.slice(-2)
            }
        })
    },
    methods:{
        getParameters(){
            this.loading = true
            SystemParameterApi.Bank(this.bankValue).then(res=>{
                if(res.data.Success){
                    this.parameters = res.data.Data
                    this.loading = false
                } else this.$result(res)
            }).catch(err=>{
                this.$result(null,err)
            })
        },
        pay(e){
            e.preventDefault()
            if(!this.validateAmount()){
                return
            }
            this.loading = true
            try { 
                const MBR_ID = this.parameters.find(p=>p.Key == "MbrId")?.Value || ""
                const SUCCESS_URL = this.parameters.find(p=>p.Key == "OkUrl")?.Value || ""
                const ERROR_URL = this.parameters.find(p=>p.Key == "FailUrl")?.Value || ""
                const TYPE = this.parameters.find(p=>p.Key == "TxnType")?.Value || ""
                const MERCHANT_PASS = this.parameters.find(p=>p.Key == "MerchantPass")?.Value || ""
                
                const HASH_DATA = [
                    MBR_ID,
                    this.orderId,
                    this.c_amount,
                    SUCCESS_URL,
                    ERROR_URL,
                    TYPE,
                    this.installment,
                    this.orderId,
                    MERCHANT_PASS
                ].join('')
    
                PaymentApi.PreparePayment({
                    Amount:this.amount,
                    OrderId:this.orderId,
                    CardNumber:this.cardNumber,
                    FullName:this.fullName,
                    GroupCode:this.code,
                    Bank:this.bankValue,
                    Installment:this.installment
                }).then(res => {
                    SystemDataApi.CalculateSHA1ASCII({PlainText:HASH_DATA}).then(res=>{
                        this.hash = res.data
                        this.$nextTick(()=>{
                            this.$refs.form.submit()
                        })
                    })
                }).catch(err=>{
                    this.loading = false
                    console.log(err)
                })
                
            } catch (error) {
                this.loading = false
                console.log(error)
            }
        },
        validateAmount(){
            const amount = Number(this.amount)
            const maxAmount = Number(this.maxAmount)
            if(!Number.isFinite(amount) || amount <= 0){
                this.$result({data:{Success:false,Message:"Ödeme tutarı 0 TL'den büyük olmalıdır."}})
                return false
            }
            if(Number.isFinite(maxAmount) && maxAmount > 0 && amount > maxAmount){
                this.$emit('update:amount',maxAmount)
                this.$result({data:{Success:false,Message:"Ödeme tutarı gönderilen ödeme tutarını aşamaz."}})
                return false
            }
            return true
        }
    },
    computed:{
        c_amount(){
            return Number(this.amount)
        },
        c_installments(){
            const amount = (t) => {
                if(this.amount){
                    let cr = t.CommissionRate || 1
                    let ins = t.Value ? Number(t.Value) : null
                    if(ins){
                        let newAmount = cr > 1 ? this.amount + (this.amount * (cr / 100)) : this.amount
                        let insAmount = newAmount / ins
                        return `${ins} x ${Additional.ConvertMoney(insAmount)} ₺`
                    }else return Additional.ConvertMoney(this.amount) + " ₺"
                }else return null
            }


            return this.installments.map(t=> {
                return {
                    value:t.Value,
                    text:t.Text,
                    com:t.CommissionRate || 1,
                    amount:amount(t)
                }
            })
        }
        
    }
}
</script>

<style>

</style>
